
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("7ShCl", function(module, exports) {

$parcel$export(module.exports, "aiMessages", () => $3d55d2ba43147efd$export$480e55f805d7990f);

var $2nPZH = parcelRequire("2nPZH");
const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $2nPZH.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    }
});

});

parcelRegister("2igSQ", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableInput", () => $f852cc0c808326c8$export$cdee65ffaf9b2fb7);

var $gwFzn = parcelRequire("gwFzn");

var $fb3kw = parcelRequire("fb3kw");

var $2xdp1 = parcelRequire("2xdp1");

var $kwjRd = parcelRequire("kwjRd");

var $idCCS = parcelRequire("idCCS");
const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};

});
parcelRegister("2xdp1", function(module, exports) {

$parcel$export(module.exports, "defaultVariableName", () => $df54c7f294e74661$export$178c63c1bbc65458);
$parcel$export(module.exports, "TEXT_TYPE", () => $df54c7f294e74661$export$ae3b897442224943);
$parcel$export(module.exports, "MULTI_LINES_TYPE", () => $df54c7f294e74661$export$a43e313f04be91d7);
$parcel$export(module.exports, "LIST_TYPE", () => $df54c7f294e74661$export$22c50a44ec8aa5dd);
$parcel$export(module.exports, "ROWS_DEFAULT", () => $df54c7f294e74661$export$d1952e7dbe0fefc9);
$parcel$export(module.exports, "COLUMNS_DEFAULT", () => $df54c7f294e74661$export$777b44f8413b254e);

var $55ggG = parcelRequire("55ggG");
const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;

});
parcelRegister("55ggG", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $446fbea06bd2a31f$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});

});


parcelRegister("kwjRd", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableInputWrapper", () => $f809923cf8cfa046$export$4af78215734bfe2b);
$parcel$export(module.exports, "TemplateVariableNameWrapper", () => $f809923cf8cfa046$export$59d0bfd82baefce0);
$parcel$export(module.exports, "TemplateVariableName", () => $f809923cf8cfa046$export$8eff3c6bf5b8c758);
$parcel$export(module.exports, "TemplateVariableType", () => $f809923cf8cfa046$export$b4ff36272a61159f);
$parcel$export(module.exports, "TemplateVariableInputFieldWrapper", () => $f809923cf8cfa046$export$e3cad7a6d45ce703);
$parcel$export(module.exports, "TemplateVariableTextareaInputFieldWrapper", () => $f809923cf8cfa046$export$e9df20cb66227872);
$parcel$export(module.exports, "ButtonStyle", () => $f809923cf8cfa046$export$bdc3c19374266b98);
$parcel$export(module.exports, "DropDownInputWrapper", () => $f809923cf8cfa046$export$c996e1cc40266f34);
/* SharedComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkxmi2 _otyrpxbi _n3tdv77o _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41e2s _2rkog0na _bfhkavxe",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1nmz9jpi _syaz1fxt _k48p4jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41e2s _2rko1wxp _syaz131l _bfhkavxe _1nmz9jpi",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _p12f1osq _o5724jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _p12f1osq _kqswh2mm _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_vr2wn7od",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("idCCS", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableInputComponent", () => $ab3c5e793706abd9$export$f57c870ff73570c7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ghftu = parcelRequire("ghftu");

var $9EtP6 = parcelRequire("9EtP6");

var $4noo5 = parcelRequire("4noo5");

var $cuAuQ = parcelRequire("cuAuQ");

var $4KS7f = parcelRequire("4KS7f");

var $3gadb = parcelRequire("3gadb");

var $kwjRd = parcelRequire("kwjRd");

var $2xdp1 = parcelRequire("2xdp1");
const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $dBxQj.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $gwFzn.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $gwFzn.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cuAuQ.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cuAuQ.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $dBxQj.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $dBxQj.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9EtP6.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            // @ts-ignore cols used to be in the list of props of TextArea but later then removed
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9EtP6.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        // @ts-ignore cols used to be in the list of props of TextArea but later then removed
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};

});


parcelRegister("jn9ek", function(module, exports) {

$parcel$export(module.exports, "isBadThirdPartyBlueprintError", () => $2f7d9ade7a6b90fb$export$9ae592643c1ef19b);
$parcel$export(module.exports, "isBadEditedFirstPartyBlueprintError", () => $2f7d9ade7a6b90fb$export$af33641014b57bba);
$parcel$export(module.exports, "isInvalidSpaceKeyError", () => $2f7d9ade7a6b90fb$export$b6b21a057779c53b);
$parcel$export(module.exports, "isRateExceededError", () => $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08);
$parcel$export(module.exports, "getTraceIdFromApolloError", () => $2f7d9ade7a6b90fb$export$69408b85ed2a0e77);
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};

});

parcelRegister("2HGN8", function(module, exports) {

$parcel$export(module.exports, "ContentAppearanceContextProvider", () => $652df36b21c46ede$export$53c04435be7a0acf);
$parcel$export(module.exports, "ContentAppearanceContextConsumer", () => $652df36b21c46ede$export$c3c73be39a08fc97);
$parcel$export(module.exports, "useContentAppearance", () => $652df36b21c46ede$export$4cedbdf2fdf3340d);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $jXpbL = parcelRequire("jXpbL");

var $8VcPj = parcelRequire("8VcPj");

var $CTedk = parcelRequire("CTedk");
const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    contentAppearance: {
        appearance: (0, $CTedk.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $gwFzn.useState)();
    const [{ collabEditProvider: collabEditProvider }] = (0, $jXpbL.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $gwFzn.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const widthValue = metadata?.editorWidth?.value;
            const version = metadata?.editorWidth?.version;
            if (widthValue) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    const draftAppearanceQuery = (0, $8VcPj.getContentAppearanceQuery)((0, $CTedk.ContentAppearancePropertyKey).DRAFT);
    const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $j1Ss3.useQuery)(draftAppearanceQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        }
    });
    const context = (0, $gwFzn.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $CTedk.ContentAppearancePropertyKey).DRAFT);
        return {
            contentAppearance: contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $gwFzn.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};

});

parcelRegister("5un3P", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DYNAMIC_CARDS_COUNT", () => $a247ba2e22f9ecac$export$12c9c8946ce83b13);
$parcel$export(module.exports, "DEFAULT_CARDS_SIZE", () => $a247ba2e22f9ecac$export$eea11e2ee6ebb03f);
$parcel$export(module.exports, "Orientation", () => $a247ba2e22f9ecac$export$df54d73aa0ec5e82);
$parcel$export(module.exports, "Alignment", () => $a247ba2e22f9ecac$export$9d7927214ed7d2cf);
$parcel$export(module.exports, "ImagePosition", () => $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2);
$parcel$export(module.exports, "CardsLayout", () => $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e);
$parcel$export(module.exports, "CardSize", () => (parcelRequire("4cOi8")).Height);

var $4cOi8 = parcelRequire("4cOi8");
const $a247ba2e22f9ecac$export$12c9c8946ce83b13 = 3;
const $a247ba2e22f9ecac$export$eea11e2ee6ebb03f = (0, $4cOi8.Height).MEDIUM;
var $a247ba2e22f9ecac$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $a247ba2e22f9ecac$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
    return Alignment;
}({});
var $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2 = /*#__PURE__*/ function(ImagePosition) {
    ImagePosition["TOP"] = "top";
    ImagePosition["MIDDLE"] = "middle";
    ImagePosition["BOTTOM"] = "bottom";
    return ImagePosition;
}({});
var $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e = /*#__PURE__*/ function(CardsLayout) {
    CardsLayout["FIXED_IMAGE_HEIGHT"] = "fixed-image-height";
    CardsLayout["FLEXIBLE_IMAGE_HEIGHT"] = "flexible-image-height";
    return CardsLayout;
}({});

});

parcelRegister("2vQcO", function(module, exports) {

$parcel$export(module.exports, "createCard", () => $d021ca2ceb8d1f69$export$b7316deff43c35f7);
$parcel$export(module.exports, "getDefaultCards", () => $d021ca2ceb8d1f69$export$adc082ec96ce9cca);
$parcel$export(module.exports, "linkCardsParameters", () => $d021ca2ceb8d1f69$export$c06a31b1c63a03bb);
$parcel$export(module.exports, "linkCardsExtensionProvider", () => $d021ca2ceb8d1f69$export$7405c372b05d8ba8);

var $gwFzn = parcelRequire("gwFzn");

var $kyKWe = parcelRequire("kyKWe");

var $2nPZH = parcelRequire("2nPZH");

var $bre0g = parcelRequire("bre0g");

var $dh538 = parcelRequire("dh538");

var $5un3P = parcelRequire("5un3P");
var $kcoxM = parcelRequire("kcoxM");

var $ekK2d = parcelRequire("ekK2d");

var $1u5CA = parcelRequire("1u5CA");

var $jmjWc = parcelRequire("jmjWc");

const $d021ca2ceb8d1f69$var$LinkCardsExtension = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pe96n",
    name: "LinkCardsExtension",
    loader: async ()=>(await (parcelRequire("lhPGT"))).LinkCardsExtension
});
const $d021ca2ceb8d1f69$var$cardImages = [
    {
        src: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=1080',
        alt: 'green mountain across body of water'
    },
    {
        src: 'https://images.unsplash.com/photo-1501436513145-30f24e19fcc8?auto=format&fit=crop&q=80&w=1080',
        alt: 'calm body of water during golden hour'
    },
    {
        src: 'https://images.unsplash.com/photo-1580100586938-02822d99c4a8?auto=format&fit=crop&q=80&w=1080',
        alt: 'body of water near mountain during daytime'
    }
];
const $d021ca2ceb8d1f69$var$i18n = (0, $2nPZH.defineMessages)({
    linkCardsMacroTitle: {
        id: "custom-sites-extensions.link-cards.manifest.macro-title",
        defaultMessage: "Cards"
    },
    linkCardsMacroDescription: {
        id: "custom-sites-extensions.link-cards.manifest.macro-description",
        defaultMessage: "Display links as cards"
    }
});
const $d021ca2ceb8d1f69$export$b7316deff43c35f7 = (imageSrc, imageAltText)=>({
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        label: '',
        isLabelHidden: false,
        labelColor: (0, $1u5CA.knownLabelColors)[0],
        imageSrc: imageSrc,
        imagePosition: (0, $5un3P.ImagePosition).MIDDLE,
        imageAltText: imageAltText
    });
let $d021ca2ceb8d1f69$var$cards = null;
const $d021ca2ceb8d1f69$export$adc082ec96ce9cca = ()=>{
    if ($d021ca2ceb8d1f69$var$cards) return $d021ca2ceb8d1f69$var$cards;
    return $d021ca2ceb8d1f69$var$cards = $d021ca2ceb8d1f69$var$cardImages.map(({ src: src, alt: alt })=>$d021ca2ceb8d1f69$export$b7316deff43c35f7(src, alt));
};
const $d021ca2ceb8d1f69$export$c06a31b1c63a03bb = (extensionTitle, isAutoscrollGateEnabled, isVisualCardsConfigUpdatesEnabled, isCardsV2GateEnabled)=>{
    var // default to false unless user already assigned autoscroll to enabled/disabled
    _parameters;
    const parameters = {
        size: (0, $5un3P.DEFAULT_CARDS_SIZE),
        cards: $d021ca2ceb8d1f69$export$adc082ec96ce9cca(),
        isAvatarShown: true,
        isPublishDateShown: false,
        extensionTitle: extensionTitle,
        version: (0, $kcoxM.CARDS_EXTENSION_VERSION_3),
        renderVariant: (0, $ekK2d.RenderVariant).MANUAL,
        isSegmentationShown: false,
        orientation: (0, $5un3P.Orientation).ROW,
        alignment: (0, $5un3P.Alignment).LEFT
    };
    if (isAutoscrollGateEnabled) (_parameters = parameters).isAutoscrollEnabled ?? (_parameters.isAutoscrollEnabled = false);
    if (isVisualCardsConfigUpdatesEnabled) {
        parameters.backgroundColor = "var(--ds-surface, #FFFFFF)";
        parameters.textColor = "var(--ds-text, #172B4D)";
    }
    if (isCardsV2GateEnabled) {
        var _parameters1, _parameters2, _parameters3;
        (_parameters1 = parameters).layout ?? (_parameters1.layout = (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT);
        (_parameters2 = parameters).isPaddingEnabled ?? (_parameters2.isPaddingEnabled = true);
        (_parameters3 = parameters).isLabelShown ?? (_parameters3.isLabelShown = true);
    }
    return parameters;
};

const $d021ca2ceb8d1f69$export$d0035282aa5b6697 = ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource, contentId: contentId })=>{
    return {
        title: intl.formatMessage($d021ca2ceb8d1f69$var$i18n.linkCardsMacroTitle),
        type: (0, $kcoxM.CARDS_EXTENSION_TYPE),
        key: (0, $kcoxM.CARDS_EXTENSION_KEY),
        description: intl.formatMessage($d021ca2ceb8d1f69$var$i18n.linkCardsMacroDescription),
        icons: {
            '48': ()=>(parcelRequire("iwcbL")).then((mod)=>mod.CardMacroIcon)
        },
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'cards-upsell',
                    action: async ()=>setUpsellModalSource('premiumCardsInsert')
                }
            ] : [
                {
                    key: 'default-cards',
                    action: {
                        type: 'node',
                        key: 'default',
                        parameters: $d021ca2ceb8d1f69$export$c06a31b1c63a03bb(intl.formatMessage($d021ca2ceb8d1f69$var$i18n.linkCardsMacroTitle), (0, $dh538.fg)('company_hub_cards_autoscroll'), (0, $dh538.fg)('company_hub_cards_visual_update'), (0, $dh538.fg)('company_hub_cards_v2'))
                    }
                }
            ],
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d021ca2ceb8d1f69$var$LinkCardsExtension, {
                                extensionNode: node,
                                contentId: contentId
                            });
                        },
                    update: async ()=>{
                        const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                        const selectedLocalId = selectedNode?.attrs?.localId;
                        if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                    }
                }
            }
        }
    };
};
const $d021ca2ceb8d1f69$export$7405c372b05d8ba8 = async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource })=>new (0, $bre0g.default)([
        $d021ca2ceb8d1f69$export$d0035282aa5b6697({
            contentId: contentId,
            editorActions: editorActions,
            openConfigPanel: openConfigPanel,
            intl: intl,
            setUpsellModalSource: setUpsellModalSource
        })
    ]);

});
parcelRegister("ekK2d", function(module, exports) {

$parcel$export(module.exports, "ITEM_FIELDS", () => $8258c4c42c170e42$export$bf7ebf7fed6e7189);
$parcel$export(module.exports, "CONDITIONAL_FIELDS", () => $8258c4c42c170e42$export$63d216eda7dcfec9);
$parcel$export(module.exports, "RenderVariant", () => $8258c4c42c170e42$export$1f60141b6ce5efed);
$parcel$export(module.exports, "SegmentationTargets", () => $8258c4c42c170e42$export$f6cd408cac7f930c);
var $8258c4c42c170e42$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
var $8258c4c42c170e42$export$63d216eda7dcfec9 = /*#__PURE__*/ function(CONDITIONAL_FIELDS) {
    CONDITIONAL_FIELDS["IS_AVATAR_SHOWN"] = "isAvatarShown";
    CONDITIONAL_FIELDS["IS_PUBLISH_DATE_SHOWN"] = "isPublishDateShown";
    CONDITIONAL_FIELDS["IS_LABEL_SHOWN"] = "isLabelShown";
    CONDITIONAL_FIELDS["IS_SEGMENTATION_SHOWN"] = "isSegmentationShown";
    return CONDITIONAL_FIELDS;
}({});
var $8258c4c42c170e42$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $8258c4c42c170e42$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});

});

parcelRegister("lhPGT", function(module, exports) {

let $f7f3483513b7509a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f7f3483513b7509a$var$load("iOWBI"),
    $f7f3483513b7509a$var$load("ha7jE"),
    $f7f3483513b7509a$var$load("9PoFc"),
    $f7f3483513b7509a$var$load("8Sd4b"),
    $f7f3483513b7509a$var$load("joJy8"),
    $f7f3483513b7509a$var$load("aHE9G"),
    $f7f3483513b7509a$var$load("7jSfd"),
    $f7f3483513b7509a$var$load("4HZlX"),
    $f7f3483513b7509a$var$load("kDqHr"),
    $f7f3483513b7509a$var$load("kjZZD"),
    $f7f3483513b7509a$var$load("ffEVr"),
    $f7f3483513b7509a$var$load("j87NQ"),
    $f7f3483513b7509a$var$load("2pYvv")
]).then(()=>parcelRequire('jWHrX'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});



parcelRegister("iwcbL", function(module, exports) {

let $d7b4ab960e89a375$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d7b4ab960e89a375$var$load("8dyWu").then(()=>parcelRequire('e3FDi'));

});


parcelRegister("g3LxX", function(module, exports) {

$parcel$export(module.exports, "useExtensionsState", () => $753deba3fe656290$export$732cb2f7b629a11e);
$parcel$export(module.exports, "useExtensionsActions", () => $753deba3fe656290$export$d50cb813b9099554);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $753deba3fe656290$var$initialState = {
    isInViewMode: true,
    isInAutoFocusMode: true,
    selectedExtensionLocalId: null,
    selectedToEditCardId: null,
    selectedToRemoveCardId: null
};
// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const $753deba3fe656290$var$actions = {
    setIsInViewMode: (isInViewMode)=>({ setState: setState })=>{
            setState({
                isInViewMode: isInViewMode
            });
        },
    setIsInAutoFocusMode: (isInAutoFocusMode)=>({ setState: setState })=>{
            setState({
                isInAutoFocusMode: isInAutoFocusMode
            });
        },
    setSelectedExtensionLocalId: (extensionLocalId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedExtensionLocalId: extensionLocalId
            });
        },
    setSelectedToEditCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToEditCardId: cardId
            });
        },
    setSelectedToRemoveCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToRemoveCardId: cardId
            });
        }
};
const $753deba3fe656290$var$ExtensionsStateStore = (0, $4ZoIm.createStore)({
    initialState: $753deba3fe656290$var$initialState,
    actions: $753deba3fe656290$var$actions,
    name: 'ExtensionsStateStore'
});
const $753deba3fe656290$export$732cb2f7b629a11e = (0, $iFWZA.createHook)($753deba3fe656290$var$ExtensionsStateStore);
const $753deba3fe656290$export$d50cb813b9099554 = (0, $iFWZA.createActionsHook)($753deba3fe656290$var$ExtensionsStateStore);

});

parcelRegister("1VNax", function(module, exports) {

$parcel$export(module.exports, "checkItems", () => $c0bf087c1d0f2640$export$3831ccf0db7ad748);
const $c0bf087c1d0f2640$var$validateItemsUrls = (items)=>{
    items.forEach((item)=>{
        if (!!item?.link && !item?.link.startsWith('http')) item.link = '';
    });
};
const $c0bf087c1d0f2640$export$3831ccf0db7ad748 = (items)=>{
    if (!items || items?.length === 0) return null;
    else if (Array.isArray(items)) {
        $c0bf087c1d0f2640$var$validateItemsUrls(items);
        return items;
    }
};

});

parcelRegister("7q60U", function(module, exports) {

$parcel$export(module.exports, "updateNodeParameters", () => $a5eaa64c2546cc45$export$9860c2f1456a166d);
$parcel$export(module.exports, "replaceSelectedNode", () => $a5eaa64c2546cc45$export$39874bca494f9ba3);
const $a5eaa64c2546cc45$export$9860c2f1456a166d = (editorActions, updatedParameters)=>{
    const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();
    const updatedNodeSelection = {
        ...selectedNodeJSON,
        attrs: {
            ...selectedNodeJSON?.attrs,
            parameters: {
                ...updatedParameters
            }
        }
    };
    editorActions.replaceSelection(updatedNodeSelection, true);
};
const $a5eaa64c2546cc45$export$39874bca494f9ba3 = (editorActions, nodeAdf)=>{
    editorActions.replaceSelection(nodeAdf, true);
};

});

parcelRegister("drkRB", function(module, exports) {

$parcel$export(module.exports, "NavigationStyle", () => $ee66395b0435b80e$export$f8af16d8231e3b4e);
$parcel$export(module.exports, "FrameSizes", () => $ee66395b0435b80e$export$f34582f4a07dd8dd);

var $4cOi8 = parcelRequire("4cOi8");
var $ekK2d = parcelRequire("ekK2d");
var $ee66395b0435b80e$export$f8af16d8231e3b4e = /*#__PURE__*/ function(NavigationStyle) {
    NavigationStyle["PROGRESS_CIRCLES"] = "progress-circles";
    NavigationStyle["THUMBNAILS"] = "thumbnails";
    return NavigationStyle;
}({});
var $ee66395b0435b80e$export$f34582f4a07dd8dd = /*#__PURE__*/ function(FrameSizes) {
    FrameSizes["NAVIGATION_THUMBNAIL"] = "navigationThumbnail";
    FrameSizes["NAVIGATION_THUMBNAIL_V2"] = "navigationThumbnailV2";
    FrameSizes["HERO"] = "hero";
    return FrameSizes;
}({});

});

parcelRegister("1Assz", function(module, exports) {

$parcel$export(module.exports, "carouselNewParametersV2", () => $ea7f503ab44e3724$export$3882df2b635374e2);
$parcel$export(module.exports, "FRAME_V2_DEFAULT_IMAGE_SRC", () => $ea7f503ab44e3724$export$b713c3bc8c446d60);
$parcel$export(module.exports, "frameNewParametersV2", () => $ea7f503ab44e3724$export$27643bf44cc02178);
$parcel$export(module.exports, "createNewFrameWithDefaultParameters", () => $ea7f503ab44e3724$export$5d30fc17e786110);
$parcel$export(module.exports, "updateLinkAndConfluencePageId", () => $ea7f503ab44e3724$export$721510bd2cdb9b4f);
$parcel$export(module.exports, "useCarouselExtensionParametersAndActions", () => $ea7f503ab44e3724$export$3cf295eeccc933e1);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $kyKWe = parcelRequire("kyKWe");

var $bknsA = parcelRequire("bknsA");

var $dh538 = parcelRequire("dh538");

var $1VNax = parcelRequire("1VNax");
var $7q60U = parcelRequire("7q60U");
var $g3LxX = parcelRequire("g3LxX");

var $4cOi8 = parcelRequire("4cOi8");
var $ekK2d = parcelRequire("ekK2d");
var $drkRB = parcelRequire("drkRB");

var $jp2S4 = parcelRequire("jp2S4");
/** This hook has been created newly for Carousel v2 development
 * We intend to decouple Cards and Carousel extensions as much as we can,
 * as migration from Confluence to Platform will be more simple
 * Much refactoring has been done with reference to cards as frames in v2 design spec
 * Where possible, we resort to referring to cards and frames
 * However, when directly referring to param attribute, we will continue to use the naming cards and cardId
 * This is because Carousel v1 macros params will need to be mapped to the frames and frameId naming, which if can be hazardous
 */ const $ea7f503ab44e3724$var$i18n = (0, $2nPZH.defineMessages)({
    placeholderTitle: {
        id: "custom-sites-extensions.carousel.placeholder.title",
        defaultMessage: "Give your frame a title"
    },
    placeholderDescription: {
        id: "custom-sites-extensions.carousel.placeholder.description",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});
const $ea7f503ab44e3724$export$3882df2b635374e2 = {
    cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $drkRB.NavigationStyle).THUMBNAILS
};
const $ea7f503ab44e3724$export$b713c3bc8c446d60 = 'https://images.unsplash.com/photo-1488470015861-8bb1317353ef?auto=format&fit=crop&q=80&w=1080';
const $ea7f503ab44e3724$export$27643bf44cc02178 = {
    [(0, $ekK2d.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    [(0, $ekK2d.ITEM_FIELDS).TEXT_COLOR]: "var(--ds-text, #172B4D)",
    [(0, $ekK2d.ITEM_FIELDS).LAYOUT]: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
    [(0, $ekK2d.ITEM_FIELDS).IMAGE_SRC]: $ea7f503ab44e3724$export$b713c3bc8c446d60,
    [(0, $ekK2d.ITEM_FIELDS).IMAGE_ALT_TEXT]: "Close-up of a vibrant green palm leaf\u2019s patterns.",
    buttonText: '',
    buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
};
const $ea7f503ab44e3724$export$4f94ab8184143ae6 = {
    imageSrc: 'https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1?auto=format&fit=crop&q=80&w=1080',
    imageAltText: 'purple and pink light illustration'
};
const $ea7f503ab44e3724$export$5d30fc17e786110 = (isCarouselV2Enabled, intl, defaultField, randomLayout)=>({
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(),
        link: '',
        isLinkUserEdited: false,
        title: isCarouselV2Enabled ? intl.formatMessage($ea7f503ab44e3724$var$i18n.placeholderTitle) : '',
        isTitleUserEdited: false,
        description: isCarouselV2Enabled ? intl.formatMessage($ea7f503ab44e3724$var$i18n.placeholderDescription) : '',
        isDescriptionUserEdited: false,
        ...$ea7f503ab44e3724$export$4f94ab8184143ae6,
        ...isCarouselV2Enabled && {
            ...$ea7f503ab44e3724$export$27643bf44cc02178,
            ...randomLayout && {
                [(0, $ekK2d.ITEM_FIELDS).LAYOUT]: randomLayout
            }
        },
        ...defaultField
    });
const $ea7f503ab44e3724$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited)=>{
    return {
        [(0, $ekK2d.ITEM_FIELDS).LINK]: link,
        [(0, $ekK2d.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $ekK2d.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false
    };
};
const $ea7f503ab44e3724$var$fetchLocalIdMacroParameters = (editorActions, localId, isCarouselV2Enabled)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    if (isCarouselV2Enabled) {
        var _params, _params1, _params2;
        params.version = (0, $jp2S4.CAROUSEL_VERSION_2);
        const { cornerStyle: cornerStyle, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = $ea7f503ab44e3724$export$3882df2b635374e2;
        (_params = params).cornerStyle ?? (_params.cornerStyle = cornerStyle);
        (_params1 = params).isAutoplayEnabled ?? (_params1.isAutoplayEnabled = isAutoplayEnabled);
        (_params2 = params).navigationStyle ?? (_params2.navigationStyle = navigationStyle);
        /* construct frames array with intercepted params */ params.cards = params.cards?.map((frame)=>{
            return {
                ...$ea7f503ab44e3724$export$27643bf44cc02178,
                // override BG color back to white for v1 carousels to maintain parity...
                [(0, $ekK2d.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-input, #FFFFFF)",
                // ... but let frame BG color (if already set, eg to default color) override again
                ...(0, (/*@__PURE__*/$parcel$interopDefault($bknsA)))(frame, [
                    'imagePosition'
                ])
            };
        }) || params.cards;
        /* there were card fields added to carousel params that were nonfunctional.
     * reconstructing params to those with them omitted
     */ params = (0, (/*@__PURE__*/$parcel$interopDefault($bknsA)))(params, [
            'size',
            'isPublishDateShown',
            'isAvatarShown'
        ]);
    } else params.version = (0, $jp2S4.CAROUSEL_VERSION_1);
    return params;
};
const $ea7f503ab44e3724$var$updateFrameInList = (frames, cardId, updatedField)=>frames.map((frame)=>{
        if (frame.cardId === cardId) return {
            ...frame,
            ...updatedField
        };
        return frame;
    });
const $ea7f503ab44e3724$export$3cf295eeccc933e1 = ({ localId: localId, editorActions: editorActions })=>{
    const [carouselParameters, setCarouselParameters] = (0, $gwFzn.useState)($ea7f503ab44e3724$var$fetchLocalIdMacroParameters(editorActions, localId, (0, $dh538.fg)('company_hub_carousel_v2')));
    const usedLayoutsRef = (0, $gwFzn.useRef)(new Set());
    const lastUsedLayoutRef = (0, $gwFzn.useRef)(null);
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $g3LxX.useExtensionsActions)();
    const { cards: frames } = carouselParameters ?? {};
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        const extensionNodeParams = $ea7f503ab44e3724$var$fetchLocalIdMacroParameters(editorActions, localId, (0, $dh538.fg)('company_hub_carousel_v2'));
        setCarouselParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const getRandomLayout = (0, $gwFzn.useCallback)(()=>{
        const allLayouts = Object.values((0, $4cOi8.CommonLayout));
        if (usedLayoutsRef.current.size >= allLayouts.length - 1) usedLayoutsRef.current = new Set();
        const availableLayouts = allLayouts.filter((layout)=>!usedLayoutsRef.current.has(layout) && layout !== lastUsedLayoutRef.current);
        const randomIndex = Math.floor(Math.random() * availableLayouts.length);
        const randomLayout = availableLayouts[randomIndex];
        usedLayoutsRef.current.add(randomLayout);
        lastUsedLayoutRef.current = randomLayout;
        return randomLayout;
    }, []);
    const updateExtensionParams = (0, $gwFzn.useCallback)((newExtensionParameters)=>{
        setCarouselParameters((prevParams)=>{
            const updatedParams = {
                ...prevParams,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const addFrame = (0, $gwFzn.useCallback)(()=>{
        const newFrame = $ea7f503ab44e3724$export$5d30fc17e786110((0, $dh538.fg)('company_hub_carousel_v2'), intl, undefined, getRandomLayout());
        updateExtensionParams({
            cards: [
                ...(0, $1VNax.checkItems)(frames) || [],
                newFrame
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newFrame.cardId);
    }, [
        frames,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        intl,
        getRandomLayout
    ]);
    const removeFrame = (0, $gwFzn.useCallback)((cardId)=>updateExtensionParams({
            cards: frames.filter((frame)=>frame.cardId !== cardId)
        }), [
        frames,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $gwFzn.useCallback)((updatedFields)=>updateExtensionParams(updatedFields), [
        updateExtensionParams
    ]);
    const updateFrameFormField = (0, $gwFzn.useCallback)((cardId, updatedField)=>{
        const updatedFrames = $ea7f503ab44e3724$var$updateFrameInList(frames, cardId, updatedField);
        updateExtensionParams({
            cards: updatedFrames
        });
    }, [
        frames,
        updateExtensionParams
    ]);
    const carouselActions = (0, $gwFzn.useMemo)(()=>({
            addFrame: addFrame,
            removeFrame: removeFrame,
            updateMainFormField: updateMainFormField,
            updateFrameFormField: updateFrameFormField
        }), [
        addFrame,
        removeFrame,
        updateMainFormField,
        updateFrameFormField
    ]);
    return {
        carouselParameters: carouselParameters,
        carouselActions: carouselActions
    };
};

});
parcelRegister("jp2S4", function(module, exports) {

$parcel$export(module.exports, "CAROUSEL_VERSION_1", () => $7d803a017dc6143e$export$9575b4f5d97a1c29);
$parcel$export(module.exports, "CAROUSEL_VERSION_2", () => $7d803a017dc6143e$export$b429752dfe934bea);
const $7d803a017dc6143e$export$9575b4f5d97a1c29 = '1';
const $7d803a017dc6143e$export$b429752dfe934bea = '2';

});


parcelRegister("bbfkc", function(module, exports) {

$parcel$export(module.exports, "ITEM", () => $6ec678c7d9ef502a$export$25d99ac3e552cf7a);
$parcel$export(module.exports, "ALIGNMENT", () => $6ec678c7d9ef502a$export$470d0905851e47a1);
$parcel$export(module.exports, "BORDER", () => $6ec678c7d9ef502a$export$8a9179e387c60c17);
$parcel$export(module.exports, "CORNERS", () => $6ec678c7d9ef502a$export$87780c3e8dee494d);
var $6ec678c7d9ef502a$export$25d99ac3e552cf7a = /*#__PURE__*/ function(ITEM) {
    ITEM["LINK"] = "link";
    ITEM["MENU"] = "menu";
    return ITEM;
}({});
var $6ec678c7d9ef502a$export$470d0905851e47a1 = /*#__PURE__*/ function(ALIGNMENT) {
    ALIGNMENT["LEFT"] = "left";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["RIGHT"] = "right";
    return ALIGNMENT;
}({});
var $6ec678c7d9ef502a$export$8a9179e387c60c17 = /*#__PURE__*/ function(BORDER) {
    BORDER["NONE"] = "none";
    BORDER["ALL_SIDES"] = "all_sides";
    BORDER["BOTTOM"] = "bottom";
    return BORDER;
}({});
var $6ec678c7d9ef502a$export$87780c3e8dee494d = /*#__PURE__*/ function(CORNERS) {
    CORNERS["ROUND"] = "round";
    CORNERS["SHARP"] = "sharp";
    return CORNERS;
}({});

});

parcelRegister("62fWd", function(module, exports) {

$parcel$export(module.exports, "ForgeUIExtensionPointProvider", () => $3c9dbf4421667f34$export$64f0f7e9be5f8ff);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $jIiuI = parcelRequire("jIiuI");
var $5U2YR = parcelRequire("5U2YR");

var $3Spjc = parcelRequire("3Spjc");
const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5U2YR.MetricsContextProvider), {
            value: {
                product: product,
                page: page
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Spjc.default), {
                client: analyticsWebClient,
                commonAttributes: {
                    moduleType: page
                },
                children: children
            })
        })
    });
};

});

var $bca036d02a6427e0$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"fpf26\",\"CommentEditor.3597d293.js\",\"2pYvv\",\"LinkCardsExtension.a0c25acd.js\",\"j87NQ\",\"modal.d69ae48d.js\",\"i4cia\",\"component-lazy.574d1e74.js\",\"ffEVr\",\"vendors~editor_icon.9473baf8.js\",\"kDqHr\",\"file-icon.c15bd8a8.js\",\"4HZlX\",\"chart-bar-icon.aef1455e.js\",\"7jSfd\",\"list-bullet-icon.2167b4bd.js\",\"kjZZD\",\"vendors~editor_icon-object.e97fc136.js\",\"ffEVr\",\"vendors~editor_icon.9473baf8.js\",\"8Sd4b\",\"component-lazy.0dfc7371.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.9fbf001d.js\",\"7ixUU\",\"datasourceTableView.2d880b6d.js\",\"91C8u\",\"refresh.8e489499.js\",\"7anKf\",\"modal.96709194.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"9gJO7\",\"modal.9b95c189.js\",\"6cVEd\",\"fire-event.32c1479b.js\",\"aZinD\",\"vendors.6874964d.js\",\"4SIAe\",\"ReadTimePopup.f0c63d8b.js\",\"9zqjh\",\"ReadTimePopup.runtime.a95d862c.js\",\"cf51e\",\"modal.5f173fb0.js\",\"iXBG8\",\"modal.runtime.9424b0d9.js\",\"iXBG8\",\"modal.runtime.9424b0d9.js\",\"9zqjh\",\"ReadTimePopup.runtime.a95d862c.js\",\"5Pnad\",\"cs.956703b3.js\",\"3qzeo\",\"da.a6e51006.js\",\"4UYlu\",\"de.0e52901f.js\",\"3qbnQ\",\"en.c857dc06.js\",\"HY4Vc\",\"en_GB.8088c875.js\",\"fJQPR\",\"en_ZZ.67fbfeed.js\",\"gxipV\",\"es.69f016fd.js\",\"3uZ1q\",\"et.ac1a0ae0.js\",\"ardvv\",\"fi.be067ec8.js\",\"cjhdF\",\"fr.498beda1.js\",\"2mWUI\",\"hu.c32b69d9.js\",\"29Sce\",\"is.02c33977.js\",\"dBvXj\",\"it.fbe42f1a.js\",\"gmdLX\",\"ja.3923bf19.js\",\"fcXn9\",\"ko.419acfa2.js\",\"lH0NU\",\"nb.082125cc.js\",\"3OEsN\",\"nl.7ba79509.js\",\"hGLdi\",\"pl.d68b8afc.js\",\"Xi5AP\",\"pt_BR.ea61b74c.js\",\"f7XHA\",\"pt_PT.e565d94b.js\",\"14AZs\",\"ro.699a99b7.js\",\"lsFbX\",\"ru.1a33c100.js\",\"ibz6c\",\"sk.b538319e.js\",\"7I8FK\",\"sv.e3c6634e.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"4iSRl\",\"tr.0b957c49.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"7yGIa\",\"zh_TW.018b8e11.js\",\"dZksg\",\"zh.be550b65.js\",\"2lsX7\",\"main.1b7a934b.js\",\"1S9KM\",\"lock-locked--lock-circle.11c51b01.js\",\"bL008\",\"lock-circle.fdb473df.js\",\"aHE9G\",\"vendors~editor_atlaskit.c31acbc7.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.f0046a0a.js\",\"c6MKV\",\"stable_vendors.93436621.js\",\"64Goy\",\"modal.863c77b1.js\",\"k1740\",\"board.e21ca1d1.js\",\"2jsRt\",\"checkbox.12ed1287.js\",\"aQp8v\",\"radio.24323b5b.js\",\"gOlh9\",\"chevron-up.044d5e4d.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.f0046a0a.js\",\"kO0mz\",\"audio-icon.3fb3ee2d.js\",\"jDjSj\",\"16.8a4cce0e.js\",\"gQLjx\",\"angle-brackets-icon.8e8a0f88.js\",\"3wmvj\",\"16.b741d755.js\",\"kIjBt\",\"angle-brackets-icon.e104d1a5.js\",\"5i5pX\",\"folder-icon.fc4f6d1b.js\",\"eA5B3\",\"image-icon.79d204dd.js\",\"8059b\",\"16.afe6487f.js\",\"7AsyI\",\"video-icon.661d0519.js\",\"hPalR\",\"16.93dce164.js\",\"8LPnw\",\"lock-locked--lock-filled.17f891f6.js\",\"2fk6g\",\"16.bea78523.js\",\"dil5i\",\"24.e2acaae5.js\",\"huUvS\",\"16.ec1fe873.js\",\"P5iE2\",\"24.874d8c90.js\",\"1oiJ6\",\"16.b49b338d.js\",\"42vdC\",\"24.8676303a.js\",\"lxiFd\",\"16.80951c67.js\",\"9Bu2S\",\"24.1eba1b1c.js\",\"eDqo1\",\"16.f4617b7e.js\",\"8pE8S\",\"24.4b97cbb2.js\",\"6HBYC\",\"16.64a21052.js\",\"ivQYH\",\"24.272a2b94.js\",\"bYxCZ\",\"16.aa8224a8.js\",\"7a9CL\",\"24.f46d75b2.js\",\"eTBsW\",\"16.fd6383aa.js\",\"8mzoy\",\"24.b3fbae03.js\",\"020xd\",\"16.f33a251e.js\",\"bjzRn\",\"24.95103356.js\",\"ls0Um\",\"16.0d741008.js\",\"fYi1a\",\"24.8dbe60cd.js\",\"eVYW1\",\"16.fd806601.js\",\"fqrMn\",\"24.a62bdaeb.js\",\"f35QR\",\"16.b6568c92.js\",\"hzK1f\",\"24.98083536.js\",\"4sSyn\",\"24.e4066b09.js\",\"dnrR3\",\"24.9b235136.js\",\"gxkp2\",\"24.2f405197.js\",\"hiqrg\",\"24.ee437072.js\",\"490Jr\",\"24.b65ff1b2.js\",\"ggkqU\",\"24.9110597b.js\",\"65smn\",\"24.c0e41410.js\",\"1fh7t\",\"24.f65169ea.js\",\"4mLGd\",\"24.c47a3404.js\",\"cMlHc\",\"24.9330c41f.js\",\"lSzlP\",\"24.1bb21f19.js\",\"5erPe\",\"24.d6e6663a.js\",\"cXodu\",\"24.4e0ad70d.js\",\"4j0Ap\",\"confluence-icon.394c835e.js\",\"87j6O\",\"jira-icon.eb7336b7.js\",\"3vYMs\",\"attachment.7777c63a.js\",\"8PsNg\",\"attachment.bdae94e9.js\",\"9UmxH\",\"task.44180bef.js\",\"d1W0Z\",\"task.dc5b3230.js\",\"hlgZa\",\"component.7f613fb8.js\",\"aQnhg\",\"component.a0c10401.js\",\"jSJrn\",\"eye-open--watch.54d1d960.js\",\"jaTPo\",\"watch.5c4b5bd8.js\",\"kgJcP\",\"thumbs-up--like.0d91b8c9.js\",\"dkV2T\",\"like.fba99a44.js\",\"513ba\",\"arrow-up.8164df13.js\",\"kefuj\",\"priority-blocker.d8096123.js\",\"bWqqo\",\"priority-critical.c242bf7a.js\",\"9ZeC1\",\"priority-high.3eb9ac43.js\",\"9zpNb\",\"priority-highest.0e78632a.js\",\"gOpe6\",\"priority-low.21ac1cc4.js\",\"RAL03\",\"priority-lowest.535dc7b3.js\",\"5nQIT\",\"priority-major.94eb9450.js\",\"l9frT\",\"priority-medium.3a2d978a.js\",\"lACXG\",\"priority-minor.d2ac136e.js\",\"ao5oO\",\"priority-trivial.965f2280.js\",\"7owaE\",\"question-circle--question.334f79c7.js\",\"9PQvE\",\"angle-brackets--code.229a6e25.js\",\"9DPul\",\"code.6512be9f.js\",\"9dfxa\",\"subtasks--subtask.85d82f30.js\",\"hl2oi\",\"subtask.c893ffae.js\",\"3wY4G\",\"goal-icon.c8c90c26.js\",\"88r9N\",\"projects-icon.c26711c5.js\",\"cqZpg\",\"manual-triggers-modal.819600d5.js\",\"aoU9B\",\"RelatedLinksModal.f210ab13.js\",\"kDLrp\",\"EmbedModal.d1a84bf4.js\",\"cXPC0\",\"EmbedModal.a727c385.js\",\"dUKeO\",\"vid-full-screen-on.89bfbdcb.js\",\"iiqDR\",\"vid-full-screen-off.edfa2cde.js\",\"9PoFc\",\"LinkCards.dde42ea3.js\",\"4hycL\",\"NoResults.9d75157a.svg\",\"lciST\",\"RestrictedContent.b8a54c0d.svg\",\"ha7jE\",\"LinkCards.dd1ccc3a.js\",\"iOWBI\",\"LinkCards.ae54363b.js\",\"8dyWu\",\"CardMacroIcon.550a1caf.js\"]"));


//# sourceMappingURL=CommentEditor.3597d293.js.map
